// Attribution: https://github.com/mui-org/material-ui/tree/next/docs/src/pages/getting-started/templates/sticky-footer
// Dependencies
import React from "react";

// Material
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

const Copyright: React.FC = () => {
  return (
    <Typography variant="body2">
      {"©"}
      {new Date().getFullYear()}
      {"."}
      {
        "Official web site of The City of Calgary, located in Calgary, Alberta, Canada."
      }
    </Typography>
  );
};

const StickyFooter: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: (theme) => theme.palette.secondary.dark,
        color: (theme) => theme.palette.secondary.contrastText,
        "& a": {
          color: "white",
          textDecorationColor: "white",
          "&:visited": {
            color: "white",
          },
          "&:focus": {
            color: "white",
          },
        },
      }}
    >
      <CssBaseline />
      <Container
        component="footer"
        sx={{
          marginTop: "2rem",
          marginBottom: "0.5rem",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          <Link href="https://www.calgary.ca/general/privacy-policy.html">
            Privacy Policy
          </Link>
          {" | "}
          <Link href="https://www.calgary.ca/general/terms-of-use.html">
            Terms of Use
          </Link>
          {" | "}
          <Link href="https://www.calgary.ca/general/accessibility.html">
            Accessibility
          </Link>
        </Typography>

        <Box
          component="footer"
          sx={{
            padding: "0.75rem 1rem",
            marginTop: "auto",
            textAlign: "center",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Copyright />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export { StickyFooter };
